import React from "react"
import moment from "moment"
import { Tooltip } from "primereact/tooltip"
import QueuedTimer from "./QueuedTimer"
import { getFullName } from "../../../utils"
import { DATE_TIME_FORMAT } from "../../../constants"

const QueueRow = React.memo(({ data, index, style }) => {
    const {
        pendingProcessLineItems,
        usersData,
        sellerPIProcessLine,
        handleCopyClick,
        handleRaisePriority,
        globalElapsedTime,
    } = data

    const eachLineItem = pendingProcessLineItems[index]

    const relatedPmBranch = usersData.PMCompanyDetails.companyBranches.find(eachBranch => eachBranch.branchId === eachLineItem.pmBranchId)
    const priorityUser = eachLineItem.priorityRaisedBy
        ? usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === eachLineItem.priorityRaisedBy)
        : null
    const skippedUser = eachLineItem.skippedBy
        ? usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === eachLineItem.skippedBy)
        : null

    return (
        <div
            key={eachLineItem.processLineItemId}
            className="table-row"
            style={{
                ...style,
                backgroundColor: eachLineItem.sellerPIPunchPriority === 1
                    ? "#E7C499"
                    : eachLineItem.skippedBy
                        ? "#a3c9ea"
                        : "lightgrey",
            }}
        >
            <div>{index + 1}</div>
            <div>
                <div className="flex flex-row justify-center items-center">
                    <span className={`pi-docno-${eachLineItem.processLineItemId}`}>{eachLineItem.PIDocNo}</span>
                    {priorityUser || skippedUser ? (
                        <Tooltip target={`.pi-docno-${eachLineItem.processLineItemId}`} position="top" autoHide>
                            {priorityUser && (
                                <>
                                    <span>Priority raised by: {getFullName(priorityUser.firstName, priorityUser.lastName)}</span>
                                    {eachLineItem.priorityRaisedAt && (
                                        <span> at {moment(eachLineItem.priorityRaisedAt).format(DATE_TIME_FORMAT)}</span>
                                    )}
                                    <br />
                                </>
                            )}
                            {skippedUser && (
                                <>
                                    <span>Skipped by: {getFullName(skippedUser.firstName, skippedUser.lastName)}</span>
                                    {eachLineItem.skippedAt && (
                                        <span> at {moment(eachLineItem.skippedAt).format(DATE_TIME_FORMAT)}</span>
                                    )}
                                </>
                            )}
                        </Tooltip>
                    ) : null}
                    <i
                        style={{ color: "grey" }}
                        className="pi pi-copy doc-copy-icon cursor-pointer ml-2"
                        onClick={() => handleCopyClick(eachLineItem.PIDocNo)}
                    ></i>
                    {eachLineItem.sellerPIPunchPriority !== 1 && (
                        <i
                            className={`pi pi-arrow-circle-up ml-2 ${sellerPIProcessLine.lineOwnersList.includes(usersData.userId)
                                ? "cursor-pointer"
                                : "cursor-not-allowed"
                                } raise-priority-${eachLineItem.processLineItemId}`}
                            onClick={() => {
                                if (sellerPIProcessLine.lineOwnersList.includes(usersData.userId)) {
                                    handleRaisePriority(eachLineItem.linkDocId)
                                }
                            }}
                            style={{ color: sellerPIProcessLine.lineOwnersList.includes(usersData.userId) ? "#393737" : "#918b8b" }}
                        ></i>
                    )}
                    <Tooltip target={`.raise-priority-${eachLineItem.processLineItemId}`} position="top" autoHide>
                        {sellerPIProcessLine.lineOwnersList.includes(usersData.userId)
                            ? "Raise Priority"
                            : "Raise Priority: Only line owners can do this."}
                    </Tooltip>
                </div>
            </div>
            <div>
                {eachLineItem.kamName} <br />
                <span style={{ fontSize: "12px", color: "grey" }}>({relatedPmBranch.branchName})</span>
            </div>
            <div>{eachLineItem.buyerCompanyName ? eachLineItem.buyerCompanyName : "-"}</div>
            <div>{eachLineItem.sellerCompanyName ? eachLineItem.sellerCompanyName : "-"}</div>
            <div>{eachLineItem.sellerPICalculatedTotalAmount ? eachLineItem.sellerPICalculatedTotalAmount : "-"}</div>
            <div>
                <QueuedTimer
                    createdAt={moment(eachLineItem.createdAt).format("DD.MM.YYYY HH:mm")}
                    docLinkId={eachLineItem.linkDocId}
                    globalElapsedTime={globalElapsedTime}
                />
            </div>
        </div>
    )
})

export default QueueRow